import { Brand } from "../../types"
import { normalizeUrl } from "./string"

export const mapBrandToDraft = (data: Brand): Brand => ({
  ...data,
  place_id: data?.place_id || data?.google_place_id || "",
  website: data.website ?? ""
})

export const mapDraftToBrand = (data: Brand): Brand => ({
  ...data,
  // Keep google_place_id in sync with the edited place_id field so clearing
  // the "Google reviews" input actually clears the stored/displayed ID.
  // Without this, the stale google_place_id rides along in the payload and the
  // backend re-derives place_id from it, resurrecting the cleared value.
  google_place_id: data.place_id,
  website: normalizeUrl(data.website)
})

export const convertBoolToEnabled = (bool: boolean) =>
  bool ? "Enabled" : "Disabled"

export const convertBoolToYesNo = (bool: boolean) => (bool ? "Yes" : "No")

export const getBrandExportLOsURL = (brandId: string) =>
  `${process.env.REACT_APP_API_HOST}/lo-export.csv?brand_id=${brandId}`
